export * from './lib/loader/dynamic-federation';